import Api from './Api';

export default new Api();
